import React, { memo, useCallback, useState } from 'react';
import { useAppContext } from '@prisjakt/ui-app-context';
import * as S from './styles';

type OwnProps = {
  children: React.ReactElement;
  className?: string;
  hideOnExpand?: boolean;
  maxHeight: number;
  size?: 'small' | 'normal';
  textIdentifier: string;
};

const ShowMore = ({
  children,
  className,
  hideOnExpand = false,
  maxHeight,
  size = 'normal',
  textIdentifier,
}: OwnProps) => {
  const { t } = useAppContext();

  const [expanded, setExpanded] = useState(false);
  const [showMore, setShowMore] = useState(false);

  const collapseOrExpand = expanded ? 'symbol.collapse' : 'symbol.expand';
  const expansionText = expanded
    ? t('common', 'button.show-less')
    : t('common', 'button.show-more');

  const textNode = useCallback((node: HTMLDivElement | null) => {
    if (node && node.parentElement) {
      const textHeight = node.getBoundingClientRect().height;
      const wrapperHeight = node.parentElement.getBoundingClientRect().height;
      setShowMore(textHeight > wrapperHeight);
    }
  }, []);

  const toggleExpansion = useCallback(() => {
    setExpanded(!expanded);
  }, [expanded]);

  return (
    <S.ShowMore
      className={className}
      expanded={expanded}
      hideOnExpand={hideOnExpand}
      maxHeight={maxHeight}
    >
      <S.TextLabel>
        <S.Text ref={textNode}>{children}</S.Text>
      </S.TextLabel>
      {showMore && (
        <S.Button
          onClick={toggleExpansion}
          aria-label={t('symbols', collapseOrExpand)}
          aria-expanded={expanded}
          aria-controls={textIdentifier}
          size={size}
        >
          {expansionText}
        </S.Button>
      )}
    </S.ShowMore>
  );
};

export default memo(ShowMore);
